<div *ngIf="open" class="image-modal-overlay" (click)="onOverlayClick()">
  <div class="image-modal-content" (click)="$event.stopPropagation()">
    <div class="image-modal-header">
      <h2>{{ title }}</h2>
      <button
        type="button"
        class="modal-close"
        (click)="close()"
        [attr.aria-label]="'dashboard.common.close' | translate">
        ×
      </button>
    </div>
    <div class="image-modal-body">
      <div class="image-loading" *ngIf="loading">
        <ion-icon name="hourglass-outline" class="loading-icon"></ion-icon>
        <p>{{ 'dashboard.common.imagePlayer.loading' | translate }}</p>
      </div>
      <img
        *ngIf="imageUrl && !loading"
        class="image-viewer"
        [src]="imageUrl"
        [alt]="title" />
    </div>
  </div>
</div>
